import { defineStore } from "pinia";

export type PageTransitionName = 'page-forward' | 'page-back' | 'page-fade' | '';

export const usePageTransitionsStore = defineStore('pageTransitions', {
    state: () => ({
        transitionName: '' as PageTransitionName,
    }),
    actions: {
        setTransition(name: PageTransitionName) {
            this.transitionName = name;
        },
        reset() {
            this.transitionName = '';
        },
    },
});
